"use client";

import Image from "next/image";
import Link from "next/link";
import { FaBookBookmark, FaDesktop, FaDownload, FaMugHot } from "react-icons/fa6";

export default function Navigation() {
    return (
        <div className="fixed top-0 w-full z-50" >
            <div className="relative rounded-lg flex flex-col md:flex-row items-center justify-center p-4 m-4 bg-slate-900/50 backdrop-blur-md" >
                <div className="absolute flex flex-row w-full items-center justify-between">
                    <Link href="/" className="flex flex-row items-center justify-center gap-2 text-white text-2xl font-bold uppercase font-roboto w-fit ml-4">
                        <Image
                            src="/logo.png"
                            width={32}
                            height={32}
                            alt={"logo"}
                            className="w-6 h-auto"
                        />
                        <div className="hidden md:block h-8 border-l-2 border-blue-900/80"></div>
                        <span className="hidden md:block">Mistaken</span>
                    </Link>
                    <Link
                        href="/panel"
                        className={`absolute right-4 flex flex-row gap-2 items-center justify-center text-white rounded cursor-pointer font-bold uppercase`}
                    >
                        <FaDesktop className="size-6" />
                        <span className="hidden lg:block">Dashboard</span>
                    </Link>
                </div>
                <div className="flex flex-row gap-4 items-center justify-between z-50">
                    <Link
                        href="/downloads"
                        className={`flex flex-row gap-2 items-center justify-center text-white rounded cursor-pointer font-bold uppercase`}
                    >
                        <FaDownload className="size-6" />
                        <span className="hidden lg:block">Downloads</span>
                        <span className="hidden md:flex items-center justify-center bg-indigo-600 px-2 py-0.5 text-xs rounded-full">
                            Launcher
                        </span>
                    </Link>
                    <div className="h-6 border-l-2 border-blue-900/80"></div>
                    <Link
                        href="/rules"
                        className={`flex flex-row gap-2 items-center justify-center text-white rounded cursor-pointer font-bold uppercase`}
                    >
                        <FaBookBookmark className="size-6" />
                        <span className="hidden lg:block">Rules</span>
                    </Link>
                    <div className="h-6 border-l-2 border-blue-900/80"></div>
                    <Link
                        href="https://ko-fi.com/ttypiarz"
                        target="_blank"
                        className={`flex flex-row gap-2 items-center justify-center text-white rounded cursor-pointer font-bold uppercase`}
                    >
                        <FaMugHot className="size-6" />
                        <span className="hidden lg:block">Support Us</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}